var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaperplane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7147 3.36572L2.23971 8.28759C2.09095 8.32826 1.95835 8.4138 1.85996 8.53256C1.76157 8.65131 1.70219 8.79751 1.68989 8.95123C1.67759 9.10496 1.71298 9.25874 1.79124 9.39162C1.86949 9.52451 1.98681 9.63004 2.12721 9.69384L10.1522 13.4907C10.3094 13.5635 10.4357 13.6898 10.5085 13.847L14.3053 21.872C14.3691 22.0124 14.4747 22.1297 14.6076 22.2079C14.7404 22.2862 14.8942 22.3216 15.0479 22.3093C15.2017 22.297 15.3479 22.2376 15.4666 22.1392C15.5854 22.0408 15.6709 21.9082 15.7116 21.7595L20.6335 4.28447C20.6708 4.15695 20.6731 4.02174 20.6401 3.89302C20.6072 3.7643 20.5403 3.64681 20.4463 3.55286C20.3524 3.45891 20.2349 3.39197 20.1062 3.35904C19.9774 3.32611 19.8422 3.32842 19.7147 3.36572Z",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3906 13.6027L14.6281 9.36523",
    stroke: "#333333",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperplane);
export default __webpack_public_path__ + "static/media/paperplane.19346d3265b488ddeb040f2c8035e34d.svg";
export { ForwardRef as ReactComponent };